import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ValidationRuleStartPanel from "../../../../ValidationRule/ValidationRulePanel/ValidationRuleStartPanel";
import { WorkSpaceUserName} from "../../../../../model/ItemModel";
import { Button } from "@mui/material";
import { MenuStyles } from "../styles/MenuStyles";


export interface IStartButton {
    idWorkspace:string;
    workspaceItem: WorkSpaceUserName;
    indexOfArray: number,
    setWorkspace: ((workSpaceUserName: WorkSpaceUserName, index: number, isUpload: boolean) => void);
    isUpload: boolean;
}

const StartButton: React.ForwardRefExoticComponent<IStartButton> = React.forwardRef(({
    idWorkspace,
    workspaceItem,
    indexOfArray,
    setWorkspace,
    isUpload
} , ref) => {

    const [isOpenPanelValidation, setIsOpenPanelValidation] = useState<boolean>(false);

    const dismissPanelValidation = () => {
        setIsOpenPanelValidation(false);
    };

    const [waitPanelResp, setWaitPanelResp] = useState<boolean>(false);

    const { t } = useTranslation();

    const openValidationPanel = (
        ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
      ) => {
        if (ev) ev.preventDefault();
        setIsOpenPanelValidation(true);
      };

    return (
        <>
            {workspaceItem.id != undefined && (
                <>
                    <Button
                        onClick={openValidationPanel}
                        sx={MenuStyles.button}
                    >{t("Start.message")}</Button>

                    {isOpenPanelValidation &&(
                        <ValidationRuleStartPanel
                            idWorkspace={idWorkspace}
                            idMongo={workspaceItem.id}
                            indexOfArray={indexOfArray}
                            setWorkspace={setWorkspace}
                            isUpload={isUpload}
                            setWaitLoader={setWaitPanelResp}
                            waitLoader={waitPanelResp}
                            isOpen={isOpenPanelValidation}
                            dismissPanel={dismissPanelValidation}
                        />
                    )}
                </>
            )}
        </>
    )
})

export default StartButton;